var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 1.90308C2.23122 1.90308 1 3.13429 1 4.65308V13.1531C1 14.6719 2.23122 15.9031 3.75 15.9031H9.00001V14.4031H3.75C3.05964 14.4031 2.5 13.8434 2.5 13.1531V4.65308C2.5 3.96272 3.05964 3.40308 3.75 3.40308H9.00001V1.90308H3.75ZM14.5303 8.37275L11.0303 4.87275L9.96967 5.93341L12.1893 8.15308H6V9.65308H12.1893L9.96967 11.8727L11.0303 12.9334L14.5303 9.43341L15.0607 8.90308L14.5303 8.37275Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutS);
export default __webpack_public_path__ + "static/media/logout-S.52d04d0288419c929b7754040c71f714.svg";
export { ForwardRef as ReactComponent };